/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Rule_Special_CharacterInputs */



/**
* | output |
* | --- |
* | "Password contains a special character (@ # $ % ( ) [ ] { } * + - _ . , : ; < > = \| & ~ ? !)" |
*
* @param {Password_Rule_Special_CharacterInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const password_rule_special_character = /** @type {((inputs?: Password_Rule_Special_CharacterInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Rule_Special_CharacterInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Password contains a special character\n(@ # $ % ( ) [ ] { } * + - _ . , : ; < > = | & ~ ? !)")
	return /** @type {LocalizedString} */ ("Le mot de passe contient un caractère spécial\n(@ # $ % ( ) [ ] { } * + - _ . , : ; < > = | & ~ ? !)")
});